import React from 'react'
import '../styles/ffmm.css'


function Ffmm() {
    return (

        <div>

            <div className='zoom-ffmm d-flex justify-content-center align-items-center flex-column'>

                <div className='zoom-bg-ffmm'></div>
                <div>
                    <span className='ffmm-tittle'>Fuerzas</span>
                    <span className='ffmm-tittle fw-bold'> Militares</span>
                </div>
            </div >

            <div className='row d-flex justify-content-center align-items-center mt-5 mb-5 mx-2'>

                <div className='ffmm-container col-lg-10'>

                    <p className='ffmm-text'>En <span className='ffmm-text-2 fw-bold'>DEFIENDEME</span>, hemos consolidado una sólida trayectoria acompañando jurídicamente a miembros activos y retirados del Ejército Nacional, entendiendo las particularidades del contexto militar y brindando soluciones legales integrales, humanas y oportunas. Durante <span className='fw-bold'>más de 15 años de experiencia</span> con el personal de las Fuerzas Militares, hemos desarrollado un enfoque especializado que combina conocimiento jurídico, lenguaje institucional y profundo respeto por la labor patriótica que desempeñan nuestros héroes.</p>

                    <h1 className='ffmm-tittle-2 text-center mt-5'>¿Qué hemos realizado con el Ejército?</h1>

                    <div className='ffmm-sub-container'>

                        <div className='col-lg-4 ffmm-img-container'>
                            <img src={`${process.env.PUBLIC_URL}/img/ffmm/FFMM_1_2.jpeg`} alt="DEFIENDEME" className="imagen-ffmm-1"></img>
                        </div>

                        <div className='col-lg-7 ffmm-list'>
                            <ul className='m-0'>

                                <li><span className='fw-bold'>Asistencia jurídica en todo el territorio nacional:</span> tanto presencial como virtual, adaptándonos a las misiones y rotaciones del personal.</li>

                                <li><span className='fw-bold'>Acompañamiento en procesos disciplinarios, administrativos y de derecho penal militar:</span> con defensa activa en todas las etapas procesales.</li>

                                <li><span className='fw-bold'>Asesoría en juntas médicas laborales, ascensos, reintegros y reconocimientos por inhabilidades:</span> atendiendo casos sensibles con confidencialidad y enfoque humano.</li>

                                <li><span className='fw-bold'>Elaboración de tutelas, derechos de petición, demandas y conceptos jurídicos:</span> en favor de la protección de derechos del personal militar y su núcleo familiar.</li>

                                <li><span className='fw-bold'>Jornadas informativas dentro de instalaciones militares:</span> con charlas sobre prevención legal y entrega de obsequios en reconocimiento a la labor del Ejército.</li>

                                <li><span className='fw-bold'>Planes jurídicos solidarios:</span> con tarifas preferenciales y beneficios adicionales como integración con servicios exequiales</li>

                                <li><span className='fw-bold'>Al ser una entidad independiente de ejercito:</span> garantizamos el acompañamiento en todas las áreas del derecho dentro y fuera de la actividad militar.</li>

                                <li><span className='fw-bold'>Entendiendo las necesidades de todos los miembros del Glorioso Ejercito Nacional y sus familias:</span> la cobertura del titular se extiende a todo su grupo familiar donde podrán contar con el acompañamiento y representación de abogados profesionales especializados en cada una de las áreas del derecho.</li>

                            </ul>
                        </div>

                    </div>

                    <h1 className='ffmm-tittle-2 text-center mt-5'>Servicios jurídicos para la línea militar</h1>

                    <div className='cards-ffmm-container mb-5 mt-5'>

                        <div class="service-card">
                            <h2 class="plan-title text-center">Plan Jurídico Integral</h2>
                            <p class="plan-price text-center">$60.000 <span className='plan-prices-int'>/ mes</span></p>
                            <ul class="plan-details">
                                <li>Cobertura para militar titular y su grupo familiar</li>
                                <li>Opción de integrar con plan exequial</li>
                                <li>Asesoría familiar opcional</li>
                            </ul>
                            <div className="text-center cta-button">¡Quiero este plan!</div>
                        </div>

                    </div>
                </div>

                <h1 className='ffmm-section-tittle text-center mt-4'>Servicios incluidos</h1>

                <div className='ffmm-container_section-2 container-xl pt-5 pb-4'>

                    <div className='col-lg-5 d-flex flex-column ffmm-section-1'>

                        <h1 className='ffmm-section-tittle-2 mb-3'>Derecho Penal y Penal Militar</h1>
                        <ul>
                            <li>Defensa en procesos penales civiles y militares</li>
                            <li>Acompañamiento en audiencias</li>
                            <li>Asistencia jurídica en casos de infracciones al Código Penal Militar</li>
                            <li>Representación en diligencias ante la Justicia Penal Militar y ordinaria</li>
                        </ul>

                        <h1 className='ffmm-section-tittle-2 mb-3'>Derecho Disciplinario y Administrativo Militar</h1>

                        <ul>
                            <li>Defensa ante procesos disciplinarios internos</li>
                            <li>Asesoría en investigaciones preliminares, cargos y sanciones</li>
                            <li>Revisión de fallos y recursos de reposición/apelación</li>
                            <li>Acompañamiento en reintegros, inhabilidades, nulidades de actos administrativos y ascensos</li>
                        </ul>

                        <h1 className='ffmm-section-tittle-2 mb-3'>Derecho Laboral y Seguridad Social</h1>

                        <ul>
                            <li>Asesoría en reconocimientos de pensiones, prestaciones y cesantías</li>
                            <li>Representación en reclamaciones por incapacidades, traslados o asignaciones</li>
                            <li>Apoyo en trámites ante Juntas Médicas Laborales (reconocimiento o revisión de pérdida de capacidad laboral)</li>

                        </ul>

                    </div>

                    <div className='col-lg-4 ffmm-img-container'>
                        <img src={`${process.env.PUBLIC_URL}/img/ffmm/FFMM_4.jpeg`} alt="DEFIENDEME" className="imagen-ffmm-2"></img>
                    </div>

                </div>

                <div className='ffmm-container_section-3 container-xl pt-5 pb-4'>

                    <div className='col-lg-4 ffmm-img-container'>
                        <img src={`${process.env.PUBLIC_URL}/img/ffmm/FFMM_2.jpeg`} alt="DEFIENDEME" className="imagen-ffmm-3"></img>
                    </div>

                    <div className='col-lg-5 d-flex flex-column ffmm-section-1'>

                        <h1 className='ffmm-section-tittle-2 mb-3'>Derecho Civil y Contractual</h1>

                        <p></p>
                        <div>
                            <ul>
                                <li>Elaboración y revisión de contratos (arriendo, compraventa, préstamos, etc...).</li>
                                <li>Representación en procesos civiles (restitución de inmueble, incumplimientos, deudas, etc.)</li>
                                <li>Defensa patrimonial y asesoría preventiva</li>
                            </ul>
                        </div>

                        <h1 className='ffmm-section-tittle-2 mb-3'>Derecho de Familia (Aplicable a núcleo familiar)</h1>

                        <ul>
                            <li>Procesos de alimentos, custodia, visitas y divorcios</li>
                            <li>Conciliaciones familiares y asesoría en conflictos sensibles</li>
                            <li>Apoyo con enfoque empático y reservado</li>
                        </ul>

                        <h1 className='ffmm-section-tittle-2 mb-3'>Métodos Alternativos de Solución de Conflictos (MASC)</h1>

                        <ul>
                            <li>Acompañamiento en conciliaciones judiciales y extrajudiciales</li>
                            <li>Mediación en conflictos civiles, familiares o comunitarios</li>
                            <li>Promoción de acuerdos de mutuo acuerdo entre partes</li>
                            <li>Acompañamiento en reintegros, inhabilidades, nulidades de actos administrativos y ascensos</li>
                        </ul>

                        <h1 className='ffmm-section-tittle-2 mb-3'>Representación Legal Integral</h1>

                        <ul>
                            <li>Elaboración de: Tutelas, Derechos de petición, demandas, conceptos jurídicos, actas y documentos para trámites administrativos o judiciales</li>
                            <li>Atención de emergencias jurídicas 24/7</li>
                        </ul>


                    </div>
                </div>

            </div>
        </div >

    )
}

export default Ffmm
